import { useQuery } from "@tanstack/react-query";
import { adaptAreas } from "src/features/Locations/adapters/adaptArea";
import cmsClient from "src/services/cmsClient";

const fetchAreas = async (regionId?: number) => {
	const url = "/homepage/admin/store/area/";
	const params = regionId !== undefined ? { region: regionId } : undefined;
	const response = await cmsClient.get<CMSPaginatedData<IArea>>(url, {
		params
	});

	return response.data.results;
};

const useAdminAreas = (regionId?: number) => {
	return useQuery(["admin-areas", regionId], () => fetchAreas(regionId), {
		select: adaptAreas,
		staleTime: 10 * 60 * 1000
	});
};

export default useAdminAreas;
